var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fuzhi") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.600000024
  }, /*#__PURE__*/React.createElement("g", {
    id: "Market-\\u6536\\u7F29",
    transform: "translate(-943.000000, -151.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-12\\u5907\\u4EFD",
    transform: "translate(923.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fuzhi",
    transform: "translate(20.270000, 71.270000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0329426,0 L12.0329426,3.42896609 L15.4620092,3.42896609 L15.4620092,15.4620427 L3.4289326,15.4620427 L3.4289326,12.0329426 L0,12.0329426 L0,0 L12.0329426,0 Z M13.7160653,5.17504394 L12.0329426,5.17504394 L12.0329426,12.0329426 L5.17504394,12.0329426 L5.17504394,13.7160653 L13.7160653,13.7160653 L13.7160653,5.17504394 Z M10.2869652,1.74597739 L1.74597739,1.74597739 L1.74597739,10.2869987 L10.2869652,10.2869987 L10.2869652,1.74597739 Z",
    id: "Fill-1"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.e265f1a5d26c716249ba34b3eb3613bc.svg";
export { ForwardRef as ReactComponent };